import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Identification from '.'

import { actionCreators } from '../../customer/actions'
import { clearSearch } from '@/checkout-instore-legacy/search/actions'
import { orderSelector } from '@/checkout-instore-legacy/order/selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionCreators, clearSearch }, dispatch)

const mapStateToProps = (state) => ({ order: orderSelector(state) })

export default connect(mapStateToProps, mapDispatchToProps, undefined, {
  pure: false,
})(Identification)
